import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from 'feature/common/landing/features/index.module.scss';
import { useTranslation } from 'react-i18next';
import className from 'classnames/bind';
import gasStation from 'images/landing/features_gas_station.png';
import parkingLot from 'images/landing/features_parking_lots.png';
import onStreetParking from 'images/landing/features_on_street_parking.png';
import autoRepair from 'images/landing/features_auto_repair.png';
import { PATHS } from 'config';
import { isMochiService } from 'config';
import { currentUrl } from 'utils/url-helper';
import amplitudeService from 'service/amplitude';
import useIntersect from 'utils/intersect-helper';

const cx = className.bind(styles);

const FeatureBlock = ({ data }) => {
  return (
    <Link to={currentUrl(data.path)}>
      <div
        className={data.classname}
        onClick={() => {
          amplitudeService.track('服務介紹頁-各業務介紹頁_點擊', {
            type: data.name,
            component: 'card',
          });
        }}
      >
        <div className={styles.img}>{data.image}</div>
        <div className={styles.info}>
          <div className={styles.title}>{data.title}</div>
          <div className={styles.desc}>{data.desc}</div>
        </div>
      </div>
    </Link>
  );
};

const Features = () => {
  const { t } = useTranslation();

  const featuresRef = useRef();
  const [gasStationshow, setGasStationShow] = useState(false);
  const [parkingLotsShow, setParkingLotsShow] = useState(false);
  const [onStreetParkingShow, setOnStreetParkingShow] = useState(false);
  const [autoRepairShow, setAutoRepairShow] = useState(false);
  const [done, setDone] = useState(false);

  const [setElement] = useIntersect(() => {
    setTimeout(() => {
      setGasStationShow(true);
    }, 0);
    setTimeout(() => {
      setParkingLotsShow(true);
    }, 300);
    setTimeout(() => {
      setOnStreetParkingShow(true);
    }, 600);
    setTimeout(() => {
      setAutoRepairShow(true);
    }, 900);
    setTimeout(() => {
      setDone(true);
    }, 1500);
  });

  useEffect(() => {
    setElement([featuresRef.current]);
  }, [setElement]);

  const gasStationClass = cx({
    card: true,
    show: gasStationshow,
    done: done,
  });

  const parkingLotsClass = cx({
    card: true,
    show: parkingLotsShow,
    done: done,
  });

  const onStreetParkingClass = cx({
    card: true,
    show: onStreetParkingShow,
    done: done,
  });

  const autoRepairClass = cx({
    card: true,
    show: autoRepairShow,
    done: done,
  });

  const featureData = [
    {
      classname: gasStationClass,
      name: '加油',
      path: PATHS.REFUELING,
      image: <img src={gasStation} alt="gas-station" loading="lazy" />,
      title: t('landing.features.gas_station'),
      desc: (
        <>
          {t('landing.features.gas_station_description_top')}
          <br />
          {t('landing.features.gas_station_description_bottom')}
        </>
      ),
    },
    {
      classname: parkingLotsClass,
      name: '停車',
      path: PATHS.PARKING,
      image: <img src={parkingLot} alt="parking-lots" loading="lazy" />,
      title: t('landing.features.parking_lot'),
      desc: (
        <>
          {t('landing.features.parking_lot_description_top')}
          <br />
          {t('landing.features.parking_lot_description_bottom')}
        </>
      ),
    },
    {
      classname: onStreetParkingClass,
      name: '路停',
      path: PATHS.ON_STREET_PARKING,
      image: <img src={onStreetParking} alt="on-street-parking" loading="lazy" />,
      title: t('landing.features.on_street_parking'),
      desc: (
        <>
          {t('landing.features.on_street_parking_description_top')}
          <br />
          {t('landing.features.on_street_parking_description_bottom')}
        </>
      ),
    },
    {
      classname: autoRepairClass,
      name: '愛車服務',
      path: PATHS.AUTO_DETAILING,
      image: <img src={autoRepair} alt="auto-repair" loading="lazy" />,
      title: t('landing.features.auto_detailing'),
      desc: (
        <>
          {t('landing.features.auto_detailing_description_top')}
          <br />
          {t('landing.features.auto_detailing_description_bottom')}
        </>
      ),
      exception: true,
    },
  ];

  return (
    <section className={styles.features} ref={featuresRef}>
      <h2>{t('landing.features.title')}</h2>
      <h3>{t('landing.features.slogan')}</h3>
      <div className={styles.content}>
        {featureData.map((feature, key) => {
          if (feature.exception && !isMochiService) return <></>;
          return <FeatureBlock data={feature} key={key} />;
        })}
      </div>
    </section>
  );
};

export default Features;
